angular
  .module('kareo.ui.shared.directives.dropdown', [])
  .directive('dropdown', ['$document', dropdownDefn]);

function dropdownDefn($document) {
  return {
    restrict: 'C',
    scope: {
      dropdownPersist: '@'
    },
    link: function dropdownLink(scope, element, attr) {
      var activeClass = 'active';
      var body = $document.find('body');
      element.bind('click', (event) => {
        // if jquery is active we need to use originalEvent
        event = (event && event.originalEvent) || event;
        event.dropdownClicked = element;
        element.toggleClass(activeClass);
      });
      body.bind('click', bodyClick);
      scope.$on('$destroy', () => {
        body.unbind('click', bodyClick);
      });
      function bodyClick(event) {
        // if jquery is active we need to use originalEvent
        event = (event && event.originalEvent) || event;
        if (event.dropdownClicked !== element) {
          element.removeClass(activeClass);
        }
      }
    }
  };
}
